<template>
	<section class="login-box">
		<div class="hero-body">
			<div class="container">
				<div class="columns is-centered">
					<div class="column is-9-tablet is-5-desktop is-4-widescreen">
						<form class="box">
							<!--  <div class="logo">
                <img src="../../assets/bullmin.svg" alt="">
              </div> -->
							<div class="field">
								<label for class="label">Usuario</label>
								<div class="control has-icons-left">
									<input v-model="user" type="username" placeholder class="input" required />
									<span class="icon is-small is-left">
										<i class="mdi mdi-account" />
									</span>
								</div>
							</div>
							<div class="field">
								<label for class="label">Senha</label>
								<div class="control has-icons-left">
									<input
										v-model="password"
										type="password"
										placeholder="*******"
										class="input"
										required
									/>
									<span class="icon is-small is-left">
										<i class="mdi mdi-lock" />
									</span>
								</div>
							</div>
							<!--  <div class="field">
                <label for="keepSignedIn" class="checkbox">
                  <input v-model="keeplogged" name="keepSignedIn" type="checkbox">
                  Manter logado
                </label>
              </div> -->
							<div class="btn-container">
								<button class="button is-success" @click.prevent="login">
									<span>Conecte-se</span>
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';
import * as Account from '../../util/Account';

export default {
	data() {
		return {
			user: '',
			password: '',
			keeplogged: false,
		};
	},
	methods: {
		async login() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.LOGIN}`, {
					usuario: this.user,
					senha: this.password,
				})
				.then((response) => {
					const { token } = response.data;
					if (response.data.error === 1) {
						this.$buefy.notification.open({
							message: response.data.message,
							type: 'is-danger',
						});
					}
					if (token) {
						Account.setUser(this.user, token);
						Account.login(token);
						this.$router.push('/');
					}
				})
				.catch((err) => {
					this.$buefy.notification.open({
						message: err.toString(),
						type: 'is-danger',
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	background: rgba(255, 255, 255, 0.25);
	box-shadow: 0 8px 32px 0 rgba(5, 7, 24, 0.26);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	border-radius: 20px;
}
.logo {
	width: 100%;
	height: 70px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.logo img {
	width: 60%;
}
.login-box {
	background-color: #ffffff;
	background-position: center; /* Center the image */
	background-repeat: no-repeat; /* Do not repeat the image */
	background-size: cover; /* Resize the background image to cover the entire container */
	width: 100%;
	display: flex;
	height: 100vh;
	align-items: center;
	justify-content: center;
}
.btn-container {
	width: 100%;
	margin-top: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.btn-container button {
	width: 200px;
	height: 38px;
	background-color: #2626bc !important;
	transition: 150ms ease-in-out;
}

.btn-container button:hover {
	background-color: #1d1d97 !important;
}
</style>

